import React, { useEffect, useState, createContext, useContext } from "react";
import api from "@/lib/api";

export const STATUS = {
  operationnel: { l: "Opérationnel", c: "bg-emerald-100 text-emerald-700", dot: "bg-emerald-500" },
  degrade: { l: "Fonctionnement dégradé", c: "bg-amber-100 text-amber-700", dot: "bg-amber-500" },
  en_panne: { l: "En panne", c: "bg-rose-100 text-rose-700", dot: "bg-rose-500" },
  hors_service: { l: "Hors service", c: "bg-gray-800 text-white", dot: "bg-gray-900" },
  en_maintenance: { l: "En maintenance", c: "bg-sky-100 text-sky-700", dot: "bg-sky-500" },
  attente_piece: { l: "En attente de pièce", c: "bg-violet-100 text-violet-700", dot: "bg-violet-500" },
  stocke: { l: "Stocké", c: "bg-gray-100 text-gray-600", dot: "bg-gray-300" },
  retire: { l: "Retiré du parc", c: "bg-gray-100 text-gray-400 line-through", dot: "bg-gray-400" },
};
export const FAIL_STATUS = {
  signalee: "Signalée", diagnostic_demande: "Diagnostic demandé", prestataire_contacte: "Prestataire contacté",
  intervention_programmee: "Intervention programmée", en_reparation: "En cours de réparation", attente_piece: "En attente de pièce",
  reparee: "Réparée", cloturee: "Clôturée", hors_service: "Appareil hors service", intervention: "Intervention",
};
export const URGENCY = { faible: "Faible", normale: "Normale", urgente: "Urgente", critique: "Critique" };
export const URG_C = { faible: "bg-gray-100 text-gray-600", normale: "bg-sky-100 text-sky-700", urgente: "bg-amber-100 text-amber-700", critique: "bg-rose-100 text-rose-700" };
export const RESULT = { conforme: "Conforme", reserve: "Conforme avec réserve", non_conforme: "Non conforme", na: "Non applicable" };
export const RESULT_C = { conforme: "text-emerald-700", reserve: "text-amber-700", non_conforme: "text-rose-700", na: "text-gray-500" };
export const LEVEL_C = { green: "bg-emerald-100 text-emerald-700", orange: "bg-amber-100 text-amber-700", red: "bg-rose-100 text-rose-700" };
export const DOC_TYPES = {
  facture_achat: "Facture d'achat", bon_livraison: "Bon de livraison", manuel: "Manuel", notice: "Notice fabricant", certificat: "Certificat",
  garantie: "Garantie", contrat: "Contrat de maintenance", devis: "Devis", facture_reparation: "Facture de réparation",
  rapport_intervention: "Rapport d'intervention", rapport_controle: "Rapport de contrôle", certificat_conformite: "Certificat de conformité",
  photo: "Photo", video: "Vidéo", documentation: "Documentation technique", declaration_vigilance: "Déclaration matériovigilance", autre: "Autre",
};
export const FREQ = { days: "jour(s)", months: "mois", years: "an(s)", custom: "Date personnalisée" };
export const BTN = "rounded-full bg-[#065F46] hover:bg-[#047857]";
export const INPUT = "mt-1 rounded-xl";

export const daysLabel = (d) => (d == null ? "" : d < 0 ? `en retard de ${-d} j` : d === 0 ? "aujourd'hui" : `dans ${d} j`);

const Ctx = createContext(null);
export function MaintProvider({ children }) {
  const [meta, setMeta] = useState(null);
  const reload = () => api.get("/maint/me").then((r) => setMeta(r.data)).catch(() => setMeta({ permissions: [] }));
  useEffect(() => { reload(); }, []);
  return <Ctx.Provider value={{ ...(meta || { permissions: [] }), loaded: !!meta, reload, can: (p) => (meta?.permissions || []).includes(p) }}>{children}</Ctx.Provider>;
}
export const useMaint = () => useContext(Ctx);

export function StatusBadge({ s, testid }) {
  const m = STATUS[s] || STATUS.operationnel;
  return <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-bold ${m.c}`}><span className={`h-2 w-2 rounded-full ${m.dot}`} />{m.l}</span>;
}

export function AuthImage({ docId, className, alt = "" }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!docId) return undefined;
    let url;
    api.get(`/maint/documents/${docId}/download?inline=true`, { responseType: "blob" }).then((r) => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => {});
    return () => url && URL.revokeObjectURL(url);
  }, [docId]);
  return src ? <img src={src} alt={alt} className={className} /> : null;
}

export const Field = ({ label, children, className = "" }) => (
  <div className={className}><p className="text-xs font-semibold text-gray-500">{label}</p>{children}</div>
);
